import { KVCardRow } from "./CardContent"
import { Typography } from "@mui/material";
export default function StartEndCardContent({ node, playbook }) {

  const isStart = node.data.isStart

  if (!playbook.coa.input_spec) {
    return <></>
  } 
  if (!playbook.coa.output_spec) {
    return <></>
  } 

  let inputs = playbook.coa.input_spec.map((input) => {
    return (
      <Typography variant="body2" color={"#b5b5b5"}>
        <b>{input.name}</b> - {input.description}
      </Typography>
    );
  });

  if (!isStart) {

    inputs = playbook.coa.output_spec.map((input) => {
      return (
        <Typography variant="body2" color={"#b5b5b5"}>
          <b>{input.name}</b> - {input.description}
        </Typography>
      );
    });

  }

return <KVCardRow
  label={isStart ? "Inputs" : "Outputs"}
  value={inputs.length > 0 ? inputs : "none"}
></KVCardRow>
}
